<div *ngIf="capturedRole && claimClientConfig">
  <div class="heading-tab">
    <h3 class="heading"><i nz-icon [nzType]="claimClientConfig.headerConfig[capturedRole].icon" nzTheme="outline"></i>
      <i>{{ claimClientConfig.headerConfig[capturedRole].heading }}</i>
    </h3>
    <div *ngIf="claimClientConfig.enableAddNewClient.includes(capturedRole)"><button nz-button nzType="primary"
        (click)="EmitOpenSearchModal()"><i> Add {{ allowedRoleTypes[capturedRole] }} </i></button></div>
  </div>

  <div class="search-results m-t-20">
    <nz-table [nzShowPagination]="false" #SearchTable [nzData]="[1]" nzSize="middle">
      <thead>
        <tr>
          <ng-container *ngFor="let column of claimClientConfig.columnMetadata">
            <th
              *ngIf="column.visibleFor && (column.visibleFor.includes('ALL') || column.visibleFor.includes(capturedRole))">
              {{ column.header}} </th>
          </ng-container>
          <th nzAlign="center" *ngIf="claimClientConfig.enableAddNewClient.includes(capturedRole)">Actions</th>
        </tr>
      </thead>
      <tbody
        *ngIf="refreshTable && clientRoleList  && clientRoleList.length > 0; else noDataTemplate">
        <ng-container *ngFor="let data of clientRoleList; let i=index">
          <tr *ngIf="data">
            <ng-container *ngFor="let column of claimClientConfig.columnMetadata">
              <td
                *ngIf="column.visibleFor && (column.visibleFor.includes('ALL') || column.visibleFor.includes(capturedRole))">
                <span *ngIf="column.key == 'isEligible'">
                  <label nz-checkbox [(ngModel)]="data[column.key]"></label>
                </span>
              
                <span *ngIf="column.key == 'policyNum' && data.policyNum">
                  {{ data.policyNum }}
                </span>
                
                <nz-select *ngIf="column.key == 'policyNum' && (!data.policyNum && policyNums.size > 1)"
                  [(ngModel)]="data.selectedPolicyNum" (ngModelChange)="onPolicyNumSelected(data)" nzPlaceHolder="Select Policy Number">    
                  <nz-option *ngFor="let policy of policyNumsIterable" [nzValue]="policy" [nzLabel]="policy"></nz-option>
                </nz-select>

                <span *ngIf="column.key == 'name'">
                  <a (click)="openClientProfile(1, data)">{{data[column.key] || '-'}}</a>
                </span>

                <span *ngIf="column.key == 'isPayer'">
                  <label nz-checkbox [(ngModel)]="data[column.key]" (ngModelChange)="setOrUpdatePayer(data.clientRefGuid,data.policyNum,'PAYER',$event)"></label>
                </span>

                <span *ngIf="column.key == 'isPrimaryInsured'">
                  <label nz-checkbox [(ngModel)]="data[column.key]" (ngModelChange)="setOrUpdatePrimaryInsured(data.clientRefGuid,data.policyNum,'PRIMARYINSURED',$event)"></label>
                </span>

                <span *ngIf="column.key == 'nomineeForInsured'">
                  <nz-select nzShowSearch id="nomineeForInsured" [(ngModel)]="data.nomineeForInsured" (ngModelChange)="onSelectNomineeFor(data)"  style="width: 100%" (click)="populateInsuredLookupFromRoleMap()">
                    <nz-option *ngFor="let item of insuredLookupForNominee.insuredCd; trackBy: item?.lookupKey"
                      [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
                    </nz-option>
                  </nz-select>
                </span>

                <span *ngIf="column.key == 'genderCd'">
                  {{data[column.key] | technicalTranslate: 'genderCd'}}
                </span>

                 <span *ngIf="column.key == 'clientTypeCd'">
                  {{data[column.key] | technicalTranslate: 'clientTypeCd'}}
                </span>

                <span *ngIf="column.key == 'splitPercentage'">
                  <nz-input-number [(ngModel)]="data.splitPercentage" (ngModelChange)="handleFinalSplitUpdate(data)" [nzMin]="0" [nzMax]="100"
                    [nzStep]="1" [nzFormatter]="numberUtil.formatterPercent" [nzParser]="numberUtil.parserPercent">
                  </nz-input-number>
                </span>

                <span *ngIf="column.key == 'relationship'">
                  <nz-select nzShowSearch id="relationCd" [(ngModel)]="data.relationship" (ngModelChange)="onRelationChange(data)" style="width: 100%">
                    <nz-option *ngFor="let item of relationCdLookup as relationCd; trackBy:item?.lookupKey"
                      [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                  </nz-select>
                </span>
                
                <span
                  *ngIf="!(['isEligible','isPayee','isPrimaryInsured','isPayer','splitPercentage', 'relationship', 'genderCd', 'name' ,'policyNum' ,'nomineeForInsured','clientTypeCd'].includes(column.key))">{{
                  data[column.key] }}</span>
              </td>
            </ng-container>
           
            <td nzAlign="center">
              <a (click)="editClient(data) ;"> <span nz-icon nzType="edit" nzTheme="outline"></span> </a> |
              <a (click)="confirmRemoveClient(data.clientRefGuid,data.policyNum)" style="color: red;"> <span nz-icon nzType="delete"
                nzTheme="outline"></span></a>
            </td>
           
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </div>
  <ng-template #noDataTemplate style="width: 1000px;">
    <tbody>
      <tr>
        <td [attr.colspan]="10">
          <app-generic-zero-ui
            [list]="clientRoleList" icon="file-search" [title]="clientZeroState.title"
            [message]="clientZeroState.message"></app-generic-zero-ui>
        </td>
      </tr>
    </tbody>
  </ng-template>

  <nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="profilePanelOpen" [nzPlacement]="'right'"
        nzTitle="Client Details" (nzOnClose)="openClientProfile(0, null)">
        <ng-container *nzDrawerContent>
          <app-view-profile-summary [IO]="selectedClientData"></app-view-profile-summary>
        </ng-container>
      </nz-drawer>
</div>